import { useQueryClient } from '@tanstack/react-query';
import type { Reply } from 'models';
import { useCallback } from 'react';
import type { CommentBookmarkDeleteAction } from '../../types';
import { getContentObjectRepliesQueryKey } from '../keys';
import type { GetContentObjectRepliesQuery } from '../use-content-object-replies-query';

const updateBookmark = ({ reply }: { reply: Reply }): Reply => ({
  ...reply,
  bookmarked: !reply.bookmarked,
});

/**
 * @deprecated Introduced as part of the #87353 feed refactor to manually patch the React Query cache
 * after each mutation. This ad-hoc cache-patching approach needs a better long-term solution.
 */
export const useUpdateCommentBookmark = () => {
  const queryClient = useQueryClient();

  return useCallback(
    ({ contentObjectId, id }: CommentBookmarkDeleteAction) => {
      queryClient.setQueriesData<GetContentObjectRepliesQuery>(
        { queryKey: getContentObjectRepliesQueryKey({ id: contentObjectId }) },
        (replies) =>
          replies?.map((reply) => {
            if (reply.id === id) {
              return updateBookmark({ reply });
            }

            if (reply.replies) {
              return {
                ...reply,
                replies: reply.replies.map((child) => (child.id === id ? updateBookmark({ reply: child }) : child)),
              };
            }

            return reply;
          }),
      );
    },
    [queryClient],
  );
};
